var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkills(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#466dec;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1898",
    "data-name": "Group 1898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon_32",
    "data-name": "Polygon 32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,57.09,17.45,70.26,25,83.42h15.1L47.7,70.26,40.13,57.09H25m-3.48-6H43.6l11,19.17-11,19.16h-22l-11-19.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_33",
    "data-name": "Polygon 33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,15.68,17.45,28.84,25,42h15.1L47.7,28.84,40.13,15.68H25m-3.48-6H43.6l11,19.16L43.6,48h-22l-11-19.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_34",
    "data-name": "Polygon 34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.41,36.27,52.83,49.44,60.41,62.6h15.1l7.58-13.16L75.51,36.27H60.41m-3.47-6H79L90,49.44,79,68.6h-22l-11-19.16Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkills);
export default __webpack_public_path__ + "static/media/Skills.ba1a3092d31b88be39b2f5e961590f3c.svg";
export { ForwardRef as ReactComponent };